/** localStorage key persisting whether the user has dismissed the post-onboarding welcome modal. */
export const WELCOME_MODAL_SEEN_KEY = 'optimise.hasSeenWelcomeModal';

/** localStorage key marking that onboarding has just completed and the welcome modal is due to be shown. */
export const WELCOME_MODAL_PENDING_KEY = 'optimise.pendingWelcomeModal';
